import { render, staticRenderFns } from "./SalesLeaveRejectModal.vue?vue&type=template&id=c0d1985e&"
import script from "./SalesLeaveRejectModal.vue?vue&type=script&lang=js&"
export * from "./SalesLeaveRejectModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports